import React from 'react';

export type NodeDataPoint = any;

interface SankeyNodeComponentProps {
  x?: number;
  y?: number;
  width?: number;
  height?: number;
  color?: string;
  title?: string;
  onMouseMove?: (e: MouseEvent) => void;
  onMouseEnter?: (e: MouseEvent) => void;
  onMouseOut?: (e: MouseEvent) => void;
}

const getCoordinates = (node: NodeDataPoint) => {
  const { x0, x1, y0, y1 } = node;
  const width = x0 !== undefined && x1 !== undefined ? x1 - x0 : undefined;
  const height = y0 !== undefined && y1 !== undefined ? y1 - y0 : undefined;

  return {
    x: x0,
    y: y0,
    width,
    height,
  };
};

export const SankeyNodeComponent = ({
  color,
  title,
  x,
  y,
  width,
  height,
  ...rectProps
}: SankeyNodeComponentProps): JSX.Element => {
  return (
    <>
      <rect {...rectProps} x={x} y={y} width={width} height={height} fill={color}>
        {title && <title>{title}</title>}
      </rect>
      {title && (
        <text
          x={x + width / 2}
          y={y + 15}
          fontSize="12"
          strokeWidth="0"
          textAnchor="middle"
          fill="#fff"
        >
          {title}
        </text>
      )}
    </>
  );
};

interface SankeyNodesComponentProps {
  nodes: NodeDataPoint[];
  titleFunc?: (node: NodeDataPoint) => string;
  colorFunc?: (node: NodeDataPoint) => string;
  onMouseMove?: (e: MouseEvent, node: NodeDataPoint) => void;
  onMouseEnter?: (e: MouseEvent, node: NodeDataPoint) => void;
  onMouseOut?: (e: MouseEvent, node: NodeDataPoint) => void;
}

export const SankeyNodesComponent = ({
  nodes,
  titleFunc,
  colorFunc,
  onMouseMove,
  onMouseEnter,
  onMouseOut,
}: SankeyNodesComponentProps): JSX.Element => {
  return (
    <g>
      {nodes.map((node) => {
        const coords = getCoordinates(node);
        return (
          <SankeyNodeComponent
            {...coords}
            key={node.id}
            color={colorFunc?.(node)}
            title={titleFunc?.(node)}
            onMouseMove={(e) => onMouseMove?.(e, node)}
            onMouseEnter={(e) => onMouseEnter?.(e, node)}
            onMouseOut={(e) => onMouseOut?.(e, node)}
          />
        );
      })}
    </g>
  );
};
